export default {

  getAll: ({ limit = 20, offset }) => `/broker/orders?filter_by=available&limit=${limit}&offset=${offset * limit}`,

  getGroup: ({ limit = 20, offset }) => `/broker/orders/group_orders?filter_by=available&limit=${limit}&offset=${offset * limit}`,

  markUnmarkAll: (movementNumber, isMark) => {
    const mark = isMark ? 'unmark_order' : 'mark_order'
    return `/broker/orders/markers?${mark}&movement_number=${movementNumber}`
  },

  getMy: ({ limit = 20, offset }) => `/carrier/orders?filter_by=available&limit=${limit}&offset=${offset * limit}`,

  markUnmarkMy: (movementNumber, isMark) => {
    const mark = isMark ? 'unmark_order' : 'mark_order'
    return `/carrier/orders/markers?${mark}&movement_number=${movementNumber}`
  }
}
